import styled from 'styled-components';
import { StyledEmbeddedWidgetCon, StyledProductItemCon } from '../../../skins';

export const StyledCompactEmbeddedWidgetCon = styled(StyledEmbeddedWidgetCon)``;

export const StyledCompactProductItemCon = styled(StyledProductItemCon)`
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
`;
